<template>
  <section class="text-center">
    <LoadingOverlay :is-active="loading">
      <div id="manuals" v-if="manuals && manuals.length > 0">
        <div v-if="manuals.length > 0" class="manual__container">
          <div v-for="(manual, index) in manuals" :key="index">
            <div v-if="manual.files.length > 0" class="manual__item">
              <div
                v-for="(file, fileIndex) in manual.files"
                :key="fileIndex"
                class="flex items-center justify-between w-full px-3 py-3"
              >
                <div class="flex items-center">
                  <PDFIcon
                    :alt="$t('icon.download')"
                    class="w-6 h-6 text-primary"
                  />
                  <p class="ml-3 text-sm md:text-lg font-ff-good-pro-cond">
                    {{ manual.name }}
                  </p>
                </div>
                <a :href="file.url" target="_blank" download>
                  <DownloadIcon
                    :alt="$t('icon.download')"
                    class="w-6 h-6 text-black"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="!loading" class="text-left">
        <WarningsNotFound class="w-full" />
      </div>
      <div v-else class="h-16" />
    </LoadingOverlay>
  </section>
</template>

<script setup>
import PDFIcon from "@/assets/svg/heroicons/PDF.svg?component";
import DownloadIcon from "@/assets/svg/heroicons/download.svg?component";

const props = defineProps({
  manuals: {
    type: Array,
    required: true,
  },
});
const productMenuStore = useProductMenuStore();

const loading = ref(false);

onMounted(() => {
  if (props.manuals && props.manuals.length > 0) {
    productMenuStore.statusManuals(true);
  }
});
</script>

<style lang="scss" scoped>
.manual__container {
  display: grid;
  gap: 1rem;

  .manual__item {
    background-color: #f5f5f5;
    border-radius: 0.5rem;

    a {
      &:not(:last-child) {
        border-bottom: 1px solid #d1d5db;
      }

      &:hover,
      &:focus {
        background: 0;
        background: rgba(255, 255, 255, 0.5);
      }

      div {
        display: flex;
        align-items: center;

        img {
          width: 1.8rem;
          height: 1.8rem;
        }

        p {
          color: #333232;
          font-size: 18px;
          font-weight: 400;
          margin: 0 0 0 1rem;
          line-height: 1;
          text-align: left;
        }
      }

      .badge {
        font-weight: 300;
        text-transform: uppercase;
      }
    }
  }
}
</style>
